import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { fileNoticeToVacateManuallyAction, leaseAndUserDetailAction } from "../../redux/actions/noticeToVacate";
import FullPageLayout from "../../layout/FullPageLayout";
import SignatureCanvas from "react-signature-canvas";
import dataURLtoBlob from "../../assets/plugins/blueimp-canvas-to-blob/js/canvas-to-blob";
import { useHistory } from "react-router-dom";
import moment from "moment";
import GoogleAutocomplete from "../../components/googleAutocomplete";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, Spinner } from "reactstrap";
import thankyouSVG from "./../../assets/img/svg/circle-check-solid.svg";
import { useParams,useLocation } from "react-router-dom";

const FileNoticeToVacateManually = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const canvasRef = useRef();
  const [formData, setFormData] = useState({
    NameFirst: "",
    NameLast: "",
    Email_01: location?.state?.email || "",
    Address_Address01: "",
    Address_Address02: "",
    Address_City: "",
    Address_State: "",
    Address_PostalCode: "",
    Date_Vacate: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isShowThankyou, setIsShowThankyou] = useState(false);
  const { zzID_PEPL } = useParams();
  const [user, setUser] = useState();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // Clear error for the changed field
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[name];
      return newErrors;
    });
  };

  useEffect(() => {
    fetchLeaseDetail();
  }, [zzID_PEPL]);

  const fetchLeaseDetail = useCallback(async () => {
    try {
      if (!zzID_PEPL) {
        return;
      }
      setLoading(true);
      const response = await dispatch(
        leaseAndUserDetailAction({ zzID_PEPL })
      );
      if (response) {
        const { person, lease } = response;
        setUser(person);
        setFormData((prev) => ({
          ...prev,
          ...person,
          Address_Address01:
            lease?.["Lease_PROP::Address_Address01_finalDisplay"] || "",
          Address_Address02: lease?.["Lease_UNIT::Number"] || "",
          Address_City: lease?.["Lease_PROP::Address_City"] || "",
          Address_State: lease?.["Lease_PROP::Address_State"] || "",
          Address_PostalCode: lease?.["Lease_PROP::Address_PostalCode"] || "",
        }));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [zzID_PEPL]);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.NameFirst.trim())
      newErrors.NameFirst = "First name is required";
    if (!formData.NameLast.trim()) newErrors.NameLast = "Last name is required";
    if (!formData.Email_01.trim()) newErrors.Email_01 = "Email is required";
    if (!formData.Address_Address01.trim())
      newErrors.Address_Address01 = "Property address is required";
    if (!formData.Date_Vacate.trim())
      newErrors.Date_Vacate = "Vacate date is required";
    if (canvasRef?.current?.isEmpty())
      newErrors.signature = "Signature is required";
    if (!formData?.Address_Address01?.trim())
      newErrors.propertyAddress = "Property address is required";
    if (!formData?.Address_Address02?.trim())
      newErrors.Address_Address02 = "Apt. number is required";
    if (!formData?.Address_PostalCode?.trim())
      newErrors.Address_PostalCode = "Postal code is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);

    const signature = dataURLtoBlob(canvasRef?.current?.toDataURL("image/png"));
    const form = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key === "Date_Vacate") {
        form.append(
          "Date_Vacate",
          moment(formData.Date_Vacate, "YYYY-MM-DD").format("MM/DD/YYYY")
        );
      } else {
        form.append(key, value);
      }
    });
    form.append("Signature_Applicant", signature);

    try {
      const result = await dispatch(fileNoticeToVacateManuallyAction(form));
      if(result){
        setIsShowThankyou(true)
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const goToBack = () => {
    history.replace("/applications-from-office");
  };

  const renderThankYouModal = () => {
    return (
      <Modal isOpen={isShowThankyou} centered size="lg">
        <ModalBody className="bg-white d-flex flex-column justify-content-center align-items-center pt-5 pb-5">
          <img src={thankyouSVG} alt="" width={150} className="mt-5"/>
          <h4 className="mt-5 text-center">{t('tenantApp.keyReturn.thankyouForSubmitingPleaseSeeAgent')}</h4>
          <button
            className="btn btn-secondary btn-lg mt-5 mb-5"
            onClick={() => {
              setIsShowThankyou(false);
              history.replace("/applications-from-office")
            }}
          >
            {t('tenantApp.keyReturn.startNewApplication')}
          </button>
        </ModalBody>
      </Modal>
    );
  };

  return (
    <FullPageLayout childrenRowStyle={{ minHeight: "90vh" }}>
      <div className="col-12 mt-5">
        <div className="row justify-content-center">
          <div className="col-6">
            <h1 className="">{t("tenantApp.keyReturn.NoticeToVacate")}</h1>
          </div>
          <div className="col-6">
            <h5 className="text-right" style={{ color: "#348fe2" }}>
              {moment().format("MMM DD, YYYY")}
            </h5>
          </div>
          <div className="col-md-6 mt-3">
            <div className="form-group">
              <label>{t("tenantApp.keyReturn.firstName")}*</label>
              <input
                type="text"
                name="NameFirst"
                value={formData.NameFirst}
                onChange={handleChange}
                className="form-control"
                placeholder={t("tenantApp.keyReturn.enterFirstName")}
                disabled={!!(zzID_PEPL && user?.NameFirst)}
              />
              {errors.NameFirst && (
                <p className="text-danger">{errors.NameFirst}</p>
              )}
            </div>
          </div>
          <div className="col-md-6 mt-3">
            <div className="form-group">
              <label>{t("tenantApp.keyReturn.lastName")}*</label>
              <input
                type="text"
                name="NameLast"
                value={formData.NameLast}
                onChange={handleChange}
                className="form-control"
                placeholder={t("tenantApp.keyReturn.EnterLastName")}
                disabled={!!(zzID_PEPL && user?.NameLast)}
              />
              {errors.NameLast && (
                <p className="text-danger">{errors.NameLast}</p>
              )}
            </div>
          </div>
          <div className="col-md-6 mt-3">
            <div className="form-group">
              <label>{t("tenantApp.keyReturn.email")}*</label>
              <input
                type="email"
                name="Email_01"
                value={formData.Email_01}
                onChange={handleChange}
                className="form-control"
                placeholder={t("tenantApp.keyReturn.EnterEmailPlaceholder")}
                disabled={location?.state?.email}
              />
              {errors.Email_01 && (
                <p className="text-danger">{errors.Email_01}</p>
              )}
            </div>
          </div>
          <div className="col-md-6 mt-3">
            <div className="form-group">
              <label>{t("tenantApp.keyReturn.dateVacate")}*</label>
              <input
                type="date"
                name="Date_Vacate"
                value={formData.Date_Vacate}
                onChange={handleChange}
                className="form-control"
                placeholder={t("tenantApp.keyReturn.enterDateVacate")}
              />
              {errors.Date_Vacate && (
                <p className="text-danger">{errors.Date_Vacate}</p>
              )}
            </div>
          </div>
          <div className="col-12">
            <h4 htmlFor="">{t("tenantApp.keyReturn.currentAddress")}</h4>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{t("tenantApp.keyReturn.propertyAddress")}*</label>
              <GoogleAutocomplete
                name="propertyAddress"
                placeholder={t("tenantApp.keyReturn.enterPropertyAddress")}
                postalCodeLabel={t("tenantApp.keyReturn.postalCode")}
                postalCodePlaceholder={t("tenantApp.keyReturn.enterPostalCode")}
                postalCodeError={errors.Address_PostalCode}
                onSelect={(event) => {
                  setFormData((prev) => ({
                    ...prev,
                    Address_Address01: event?.extractedAddress?.addressLine1,
                    Address_City: event?.extractedAddress?.city,
                    Address_State:  event?.extractedAddress?.state,
                    Address_PostalCode: event?.extractedAddress?.postalCode,
                  }));
                  const tempError = { ...errors };
                  delete tempError.propertyAddress;
                  delete tempError.Address_PostalCode;
                  setErrors(tempError);
                }}
              />
            </div>

            {errors.propertyAddress && (
              <p className="text-danger">{errors.propertyAddress}</p>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{t("tenantApp.keyReturn.Apt")}*</label>
              <input
                type="text"
                name="Address_Address02"
                value={formData.Address_Address02}
                onChange={handleChange}
                className="form-control"
                placeholder={t("tenantApp.keyReturn.enterApt")}
              />
            </div>
            {errors.Address_Address02 && (
              <p className="text-danger">{errors.Address_Address02}</p>
            )}
          </div>
          <div className="col-12 mt-3">
            <div className="d-flex align-items-end justify-content-between">
              <label> {t("tenantApp.agreement_.sign_here")}*</label>
              <button
                className="btn btn-sm btn-secondary"
                onClick={() => canvasRef?.current?.clear()}
              >
                {t("tenantApp.agreement_.clear")}
              </button>
            </div>
            <SignatureCanvas
              ref={canvasRef}
              backgroundColor="#FFFFFF"
              canvasProps={{
                style: {
                  width: "100%",
                  height: 250,
                  border: `1px solid ${errors?.signature ? "red" : "#d5dbe0"}`,
                },
              }}
              style={{ width: "200%" }}
              dotSize={1}
              minWidth={1}
              maxWidth={1}
              minDistance={1}
              onEnd={() => {
                const tempError = { ...errors };
                delete tempError.signature;
                setErrors(tempError);
              }}
            />
            {errors.signature && (
              <p className="text-danger">{errors.signature}</p>
            )}
          </div>
          <div className="col-12 mt-4">
            <div className="row justify-content-end">
              <div className="col-2">
                <button className="btn btn-secondary w-100" onClick={goToBack}>
                  {t("tenantApp.keyReturn.mainMenu")}
                </button>
              </div>
              <div className="col-2">
                <button
                  className="btn btn-primary w-100"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner color="white" size="sm">
                      Loading...
                    </Spinner>
                  ) : (
                    t("tenantApp.keyReturn.Submit")
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderThankYouModal()}
    </FullPageLayout>
  );
};

export default FileNoticeToVacateManually;
